<template>
  <form class="bg-dark text-white rounded position-relative"
        :action="action"
        :class="{ 'mobile-light' : mobileLight}"
        @submit="emitSubmit"
  >
    <b-row class="p-3 px-md-4 align-items-center">
      <h2 v-show="message" class="col-12 col-xl-auto mb-xl-0 text-center text-sm-left" :class="{ 'd-xl-none' : isOpened}">{{ message }}</h2>
      <div :class="[isOpened ? 'col-12' : 'col']">
        <ErrorInput class="border-dark-sm rounded"
                    :submit-on-close="submitOnClose"
                    :initial-keyword="initialKeyword"
                    :ajax="ajax"
                    :placeholder="placeholder"
                    :search-label="translatedLabel('searchButton', 'shared_CommonFunctional')"
                    :empty-label="translatedLabel('searchButton', 'shared_CommonFunctional')"
                    @change="isOpen"
                    @submit="submitForm"
        />
      </div>
    </b-row>
    <input ref="submitBtn" type="submit" class="d-none">
    <div v-if="disabled" class="mask disabled rounded" />
  </form>
</template>

<script>
import ErrorInput from '@/components/ui/forms/ErrorInput'
import qs from 'qs'

export default {
  conceptName: 'shared_CommonFunctional',
  components: {
    ErrorInput
  },
  props: {
    action: {
      type: String,
      required: false
    },
    message: {
      type: String,
      required: false
    },
    initialKeyword: {
      type: String,
      required: false
    },
    placeholder: {
      type: String,
      required: false
    },
    ajax: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    submitOnClose: {
      type: Boolean,
      required: false,
      default: true
    },
    mobileLight: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      isOpened: false,
      value: ''
    }
  },
  methods: {
    isOpen(s) {
      this.isOpened = s
    },
    emitSubmit(e) {
      this.$emit('search', this.value)
      if (this.ajax) e.preventDefault()
    },
    submitForm(k) {
      this.value = k
      this.updateUrlParam('keyword', k)
      this.$refs['submitBtn'].click()
    },
    updateUrlParam(keyword, value) {
      if (window.history && history.replaceState) {
        let _newAddr = location.origin + location.pathname

        if (location.href.indexOf('?') > 0) {
          let items = qs.parse(location.search.substr(1))
          if (value) items[keyword] = value; else delete items[keyword]
          if (Object.entries(items).length > 0) _newAddr += '?' + qs.stringify(items)
        } else if (value !== '') _newAddr += '?' + keyword + '=' + value

        history.replaceState('', '', _newAddr)
      }
    }
  }
}
</script>

<style lang="scss">
@import '../../scss/colors';
@import '../../scss/grid';

.mobile-light {
  @include media-breakpoint-down('sm') {
    background: $white !important;
    color: $black !important;

    .border-dark-sm {
      border: 1px solid $gray-400;
    }
  }
}
</style>
